module.exports = __webpack_public_path__ + "img/32.9fd41643.svg";